import { createRoute } from '@tanstack/react-router'
import { authLayoutRoute } from 'src/layouts/routes'

import { TechWorksPage } from '..'

export const techWorksRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  component: () => <TechWorksPage />,
  path: '/tech-works'
})
